import { render } from "./Hj006.vue?vue&type=template&id=892f6266&ts=true"
import script from "./Hj006.vue?vue&type=script&lang=ts"
export * from "./Hj006.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__